import { NgModule } from '@angular/core';
import { FilterVisibleLayersPipe } from './filter-visible-layer.pipe';

@NgModule({
  declarations: [FilterVisibleLayersPipe],
  exports: [FilterVisibleLayersPipe],
})
export class FilterVisibleLayersModule {}
